export default {
    API_ENDPOINT: 'https://green-thumbs-up.herokuapp.com/api',
    API_KEY: process.env.REACT_API_KEY,
}